import { Component } from '@angular/core';
import { SHARED_STANDALONE_IMPORTS } from 'app/shared/standalone-imports';

@Component({
  selector: 'app-header-app',
  templateUrl: './header-app.component.html',
  styleUrls: ['./header-app.component.scss'],
  standalone: true,
  imports: [...SHARED_STANDALONE_IMPORTS],
})
export class HeaderAppComponent {}
